/**
 * Announcement Bar — Message rotation on mobile
 * Cycles through .announcement-bar span elements with a fade transition.
 * On desktop all messages are visible side-by-side (CSS handles layout),
 * so this script only activates rotation when more than one message exists.
 */
(function() {
  'use strict';

  var messages = document.querySelectorAll('.announcement-bar span');
  if (!messages.length || messages.length < 2) return;

  var currentIndex = 0;
  var intervalMs = 4000;

  /* Ensure the first message is visible */
  messages[0].classList.add('active');

  /**
   * On mobile the CSS positions messages absolutely and hides them via
   * opacity. The .active class makes the current message visible.
   * On desktop all spans are shown inline so the active class is harmless.
   */
  setInterval(function() {
    messages[currentIndex].classList.remove('active');
    currentIndex = (currentIndex + 1) % messages.length;
    messages[currentIndex].classList.add('active');
  }, intervalMs);
})();
